import React from "react";

const blogData = [
  {
    id: 1,
    image: "/images/keyword/7.jpg",
    title: "Pune to Mahabaleshwar Cabs",
    delay: "200ms",
    link: "/Pune-to-Mahabaleshwar-Cabs",
  },
  {
    id: 2,
    image: "/images/keyword/26.jpg",
    title: "Pune to Goa Cabs",
    delay: "400ms",
    link: "/Pune-to-Goa-Cabs",
  },
  {
    id: 3,
    image: "/images/keyword/33.jpg",
    title: "Pune to Kolhapur Cab",
    delay: "600ms",
    link: "/Pune-to-Kolhapur-Cab",
  },
];

const BlogOne = () => {
  return (
    <section
      className="blog-one section-space blog-one--two text-center"
      id="blog"
    >
      <div className="container">
        <div className="blog-one__top">
          <div className="row gutter-y-50 align-items-center text-center">
            <div className="col-lg-12 text-center">
              <div className="sec-title sec-title--center">
                <div className="sec-title__top">
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">our latest news</h6>
                  <div className="sec-title__shape"></div>
                </div>
                <h3 className="sec-title__title">latest news and blog</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-one__inner">
        <div className="container">
          <div className="row gutter-y-30 gutter-x-30">
            {blogData.map((blog) => (
              <div key={blog.id} className="col-md-6 col-lg-4 col-xl-4">
                <div
                  className="blog-card "
                  data-wow-duration="1500ms"
                  data-wow-delay={blog.delay}
                >
                  <div className="blog-card__image text-center">
                    <img src={blog.image} alt={blog.title} />

                    <a href={blog.link} className="blog-card__image__link">
                      <span className="sr-only">{blog.title}</span>
                    </a>

                    <ul className="list-unstyled blog-card__meta">
                      <li>
                        <a href="#">
                          <span className="blog-card__meta__icon">
                            <i className="icon-user"></i>
                          </span>
                          Lotus Cab
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="blog-card__content">
                    <h3 className="blog-card__title">
                      <a href={blog.link}>{blog.title}</a>
                    </h3>

                    <a href={blog.link} className="blog-card__link">
                      <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="blog-one__shape">
        <div className="blog-one__shape__one"></div>
        <div className="blog-one__shape__two"></div>
      </div>
    </section>
  );
};

export default BlogOne;
